export const scrollToBottom = () => {
  const conversationDetailsDialog = document.getElementById(
    'conversationDetailsDialog'
  )

  if (conversationDetailsDialog) {
    conversationDetailsDialog.scrollTop =
      conversationDetailsDialog.scrollHeight
  }
}
